import React, { useEffect, useState } from 'react';
import BackButton from '../Components/BackButton';
import { KeyRound, LockKeyhole, CircleUserRound, Info } from 'lucide-react';
import OffCanvas from '../Components/OffCanvas'; // Import the Offcanvas component
import LanguageSwitcher from '../Components/LanguageSwitcher';


export default function Profile() {

    const [offCanvasTitle, setOffcanvasTitle] = useState('');
    const [user, setUser] = useState('');


    const openOffcanvas = (content) => {
        setOffcanvasTitle(content);
    };

    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem("AV_User_Data")))

    }, [])

    const links = [
        ...(user.ShowTC === true ? [{ icon: <KeyRound strokeWidth={1} />, label: "Terms & Conditions"}] : []),
        ...(user.ShowPP === true ? [{ icon: <LockKeyhole strokeWidth={1} />, label: "Privacy Policy"}] : []),
        ...(user.showMyAccountDetails === true ? [{ icon: <CircleUserRound strokeWidth={1} />, label: "My Account" }] : []),
        ...(user.showUnsub === true ? [{ icon: <Info strokeWidth={1} />, label: "Subscription Information" }] : []),
    ];



    return (
        <div className='container'>
            <BackButton />

            <h1 className='mt-5' style={{ paddingLeft: '10px' }}>Profile</h1>


            <ul>
                {links.map((item, index) => (
                    <li
                        key={index}
                        className="d-flex gap-3 align-items-center"
                        data-bs-toggle="offcanvas" data-bs-target="#infoOffcanvas" onClick={() => openOffcanvas(item.label)}
                        style={{ cursor: 'pointer' }} >
                        {item.icon}
                        {item.label}
                    </li>
                ))}


                <div className='mt-5 p-2' >
                    <h1>Language</h1>

                    <div style={{width:'100%' , height:'40px'}} >
                    <LanguageSwitcher />
                    </div>
                </div>
            </ul>


            <OffCanvas id="infoOffcanvas" title={offCanvasTitle} />

        </div>
    );
}





